import { render, staticRenderFns } from "./bell-ring.vue?vue&type=template&id=108957c4"
import script from "./bell-ring.vue?vue&type=script&lang=js"
export * from "./bell-ring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports